import { graphql } from '@prophecy/graphql-types/graphql';
export const getUrlToWorkspaceMappingsQuery = graphql(`
  query getUrlToWorkspaceMappings {
    getUrlToWorkspaceMappings {
      url
      workspace
      dataPlaneUrl
    }
  }
`);
